import { View } from './view'

export const SmallButton = View
